import React from 'react';
import './App.css';
import {useSelector} from 'react-redux';
import {AppState} from './store';
import {ErrorModal} from './modals/ErrorModal';
import {Route, Routes} from 'react-router-dom';
import {ViewNotFound} from './views/ViewNotFound';
import {StatusDetail} from './containers/StatusDetail';
import {Container} from 'react-bootstrap';
import {EtjanstHeader} from './components/EtjanstHeader/EtjanstHeader';

function App() {
    const { requestError } = useSelector((state: AppState) => state.generalStore);
    return (
        <div className="App">
            <EtjanstHeader />
            { requestError && <ErrorModal message={requestError.message} showModal={true} /> }
                <Container key={"main_container"}>
                    <main id="mainContent">
                        <div>
                            <Routes>
                                <Route path="/lmakort/:key" element={<StatusDetail/>} />
                                <Route path="*" element={<ViewNotFound/>} />
                            </Routes>
                        </div>
                    </main>
                </Container>
        </div>
    );
}

export default App;
